import React from 'react'
import './Loading.css'

function Loading({style}) {
  return (
    <div className='loading' style={style}></div>
  )
}

export default Loading